import { Group, Stack, Text, Tooltip } from "@mantine/core";
import { IconShare2 } from "@tabler/icons-react";

import { WhatsNewUpdate } from "../update";

export const update20240111: WhatsNewUpdate = {
  id: "7B84D968-5D46-48A2-AF74-04A3165EB85F",
  date: "2024-01-11",
  subject: (
    <Group spacing="xs">
      Sharing
      <IconShare2 />
    </Group>
  ),
  content: (
    <Stack>
      <Text>
        fs-checklist-studio now supports sharing documents. Click the{" "}
        <Tooltip label="Share Document">
          <IconShare2 size={14} />
        </Tooltip>
        icon in the editor to generate a unique URL that can be shared with anyone else. Shared
        checklists can be added to your library or imported directly into the editor, so you can
        "fork" documents and make them your own.
      </Text>
      <Text>
        Generated URLs are unique to the state of your document, frozen in time. If you make further
        changes to your document, you'll need to generate a new share URL.
      </Text>
    </Stack>
  ),
};
